import { power_up_layout } from "./components/power-up-layout/PowerUpLayout.strings.ts";
export const powerUpCommonStrings = {
  power_up_layout,
};
